import { Header } from "@components/site/Header"
import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export const meta: ViewMeta = {
  templateName: "Contact Page",
}

export default defineView("template-contact", (props) => {
  return (
    <>
      <Header noPattern barClassName="!bg-slate200" />
      <div className="relative w-full">
        <ContentBlocks blocks={props.page?.contentBlocks} />
      </div>
    </>
  )
})
